export const formatNumberToEuropeanStyle = (number, isFormatted = false) => {
    return isFormatted ?
        number ? Intl.NumberFormat('en-US', {
            notation: 'compact',
            maximumFractionDigits: 1,
        }).format(number) : 0 : number?.toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 9,
            useGrouping: true,
        }) ?? 0;
}